<template>
    <div dir="rtl" class="mr-8 px-4 sm:px-6 lg:px-8">
        <div class="sm:flex sm:items-center">
            <div class="sm:flex-auto">
                <h1 class="text-xl font-semibold text-gray-900">الدارسين الغير مفعلين</h1>
                <p class="mt-2 text-sm text-gray-700"></p>
            </div>
        </div>
        <!-- Search Section -->
        <div class="mt-4 mb-6">
            <div class="flex flex-col sm:flex-row gap-4">
                <div class="flex-1">
                    <input
                        v-model="searchQuery"
                        type="text"
                        placeholder="البحث في الجدول..."
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <button
                    @click="clearSearch"
                    class="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                >
                    مسح البحث
                </button>
            </div>
        </div>

        <div class="mt-8 flex flex-col">
            <div class="sm:flex-auto">
                <h1 class="text-lg font-medium text-gray-900">تفعيل الحسابات الجديدة</h1>
                <p class="mt-2 text-xs text-gray-700"></p>
            </div>
            <div v-if="!this.errorMessageStatus" class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                    <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                        <div class="mb-4 text-sm text-gray-700">
                            عرض {{ students.length }} من أصل {{ totalElements }} نتيجة
                            (الصفحة {{ currentPage + 1 }} من {{ totalPages }})
                        </div>
                        <table class="min-w-full divide-y divide-customHafadhColor">
                            <thead class="bg-customHafadhColor">
                                <tr>
                                    <th scope="col"
                                        @click="sortBy('fullName')"
                                        class="py-3.5 pr-4 pl-3 text-right text-sm font-semibold text-gray-900 sm:pr-6 cursor-pointer hover:bg-customHafadhColor/80">
                                        <div class="flex items-center gap-2">
                                            <span>الاسم</span>
                                            <span v-if="sortField === 'fullName'" class="text-xs">
                                                {{ sortOrder === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" 
                                        @click="sortBy('email')"
                                        class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900 cursor-pointer hover:bg-customHafadhColor/80">
                                        <div class="flex items-center gap-2">
                                            <span>الايميل</span>
                                            <span v-if="sortField === 'email'" class="text-xs">
                                                {{ sortOrder === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" 
                                        @click="sortBy('phone')"
                                        class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900 cursor-pointer hover:bg-customHafadhColor/80">
                                        <div class="flex items-center gap-2">
                                            <span>الجوال</span>
                                            <span v-if="sortField === 'phone'" class="text-xs">
                                                {{ sortOrder === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" 
                                        @click="sortBy('age')"
                                        class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900 cursor-pointer hover:bg-customHafadhColor/80">
                                        <div class="flex items-center gap-2">
                                            <span>العمر</span>
                                            <span v-if="sortField === 'age'" class="text-xs">
                                                {{ sortOrder === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" 
                                        @click="sortBy('qualificationValue')"
                                        class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900 cursor-pointer hover:bg-customHafadhColor/80">
                                        <div class="flex items-center gap-2">
                                            <span>المؤهل</span>
                                            <span v-if="sortField === 'qualificationValue'" class="text-xs">
                                                {{ sortOrder === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" 
                                        @click="sortBy('createdDate')"
                                        class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900 cursor-pointer hover:bg-customHafadhColor/80">
                                        <div class="flex items-center gap-2">
                                            <span>تاريخ ووقت التسجيل</span>
                                            <span v-if="sortField === 'createdDate'" class="text-xs">
                                                {{ sortOrder === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" 
                                        @click="sortBy('massaratValue')"
                                        class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900 cursor-pointer hover:bg-customHafadhColor/80">
                                        <div class="flex items-center gap-2">
                                            <span>المسار</span>
                                            <span v-if="sortField === 'massaratValue'" class="text-xs">
                                                {{ sortOrder === 'asc' ? '↑' : '↓' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        أجزاء القرآن
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        مدة الاشتراك
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        الحضور
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        الورد اليومي
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        التسميع
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        التنشيط
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 bg-white">
                                <tr v-for="(student, index) in paginatedStudents" :key="index">
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        {{ student.fullName }}
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {{ student.email }}
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {{ student.phone }}
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {{ student.age || '-' }}
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {{ student.qualificationValue || '-' }}
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {{ formatDate(student.createdDate) }}
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {{ student.massaratValue || '-' }}
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        <button
                                            v-if="student.quranParts && student.quranParts.length > 0"
                                            @click="openQuranPartsModal(student)"
                                            class="text-customHafadhColor hover:text-customHafadhColorHover underline font-medium">
                                            عرض الأجزاء ({{ student.quranParts.length }})
                                        </button>
                                        <span v-else class="text-gray-400">-</span>
                                    </td>
                                    <td>
                                        <select
                                            class="text-white bg-customHafadhColor hover:bg-customHafadhColorHover
                                         focus:ring-4 focus:outline-none focus:ring-customHafadhColor font-medium rounded-lg text-sm
                                          px-5 py-2.5 text-center inline-flex items-center dark:bg-customHafadhColor dark:hover:bg-customHafadhColorHover dark:focus:ring-customHafadhColor w-31 h-10"
                                            v-model="student.courseDurationId">
                                            <option disabled value="" selected>الرجاء اختيار مدة الاشتراك</option>
                                            <option v-for="master in masterDurationList" :key="master.id"
                                                :value="master.id">
                                                {{ master.durationDesc }}</option>
                                        </select>
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        <input v-model="student.ATTENDANCE" type="number"
                                            class="block w-16 h-5 p-2 border rounded" min="1" />
                                    </td>
                                    <td
                                        class="relative whitespace-nowrap py-4 pr-3 pl-4 text-right text-sm font-medium sm:pl-6">
                                        <input v-model="student.SELF_REVIEW" type="number"
                                            class="block w-16 h-5 p-2 border rounded" min="1" />
                                    </td>
                                    <td
                                        class="relative whitespace-nowrap py-4 pr-3 pl-4 text-right text-sm font-medium sm:pl-6">
                                        <input v-model="student.MEMORY" type="number"
                                            class="block w-16 h-5 p-2 border rounded" min="1" />
                                    </td>
                                    <td>
                                        <button type="submit" @click="activateStudent(student)"
                                            :class="this.canActivate(student) ? 'enabled-button' : 'disabled-button'"
                                            :disabled="!canActivate(student)">تنشيط</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Pagination -->
                <div class="mt-6 flex items-center justify-between">
                    <div class="flex-1 flex justify-between sm:hidden">
                        <button
                            @click="previousPage"
                            :disabled="currentPage === 0 || filteredAndSortedStudents.length === 0"
                            class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            السابق
                        </button>
                        <button
                            @click="nextPage"
                            :disabled="!hasNext || filteredAndSortedStudents.length === 0"
                            class="mr-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            التالي
                        </button>
                    </div>
                    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                        <div>
                            <p class="text-sm text-gray-700">
                                عرض <span class="font-medium">{{ startIndex + 1 }}</span> إلى <span class="font-medium">{{ endIndex }}</span>
                                من أصل <span class="font-medium">{{ totalElements }}</span> نتيجة
                            </p>
                        </div>
                        <div>
                            <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                                <button
                                    @click="previousPage"
                                    :disabled="currentPage === 0 || totalElements === 0"
                                    class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    <span class="sr-only">السابق</span>
                                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                                
                                <button
                                    v-for="page in visiblePages"
                                    :key="page"
                                    @click="goToPage(page)"
                                    :class="[
                                        page === currentPage + 1
                                            ? 'z-10 bg-customHafadhColor border-customHafadhColor text-white'
                                            : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                                        'relative inline-flex items-center px-4 py-2 border text-sm font-medium'
                                    ]"
                                >
                                    {{ page }}
                                </button>
                                
                                <button
                                    @click="nextPage"
                                    :disabled="!hasNext || totalElements === 0"
                                    class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    <span class="sr-only">التالي</span>
                                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="this.errorMessageStatus">
                <h1 style="color: red;"> {{ this.errorMessage }}</h1>
            </div>
        </div>

        <!-- Quran Parts Modal -->
        <div v-if="showQuranPartsModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <!-- Background overlay -->
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" @click="closeQuranPartsModal"></div>

                <!-- Modal panel -->
                <div class="inline-block align-bottom bg-white rounded-lg text-right overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                    <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div class="sm:flex sm:items-start">
                            <div class="mt-3 text-center sm:mt-0 sm:text-right w-full">
                                <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4" id="modal-title">
                                    أجزاء القرآن - {{ selectedStudentName }}
                                </h3>
                                <div class="mt-2">
                                    <div v-if="selectedStudentQuranParts && selectedStudentQuranParts.length > 0" class="space-y-2">
                                        <div
                                            v-for="(part, index) in selectedStudentQuranParts"
                                            :key="part.id || index"
                                            class="p-3 bg-gray-50 rounded-lg border border-gray-200">
                                            <p class="text-sm font-medium text-gray-900">
                                                {{ part.description || `جزء ${part.id}` }}
                                            </p>
                                        </div>
                                    </div>
                                    <p v-else class="text-sm text-gray-500">لا توجد أجزاء مسجلة</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                        <button
                            type="button"
                            @click="closeQuranPartsModal"
                            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-customHafadhColor text-base font-medium text-white hover:bg-customHafadhColorHover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-customHafadhColor sm:ml-3 sm:w-auto sm:text-sm">
                            إغلاق
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import url from '@/url';
import axios from 'axios';
import { defineComponent } from 'vue';

class MasterDurationDto {
    constructor(data) {
        this.id = data.id || null;
        this.durationDesc = data.durationDesc || null;
        this.durationValue = data.durationValue || null;
    }
}

class StudentDto {
    constructor(data) {
        this.id = data.id || null;
        this.email = data.email || null;
        this.fullName = data.fullName || null;
        this.engagementPreference = data.engagementPreference || null;
        this.qualificationValue = data.qualificationValue || null;
        this.qualificationId = data.qualificationId || null;
        // this.nationalId = data.nationalId || null; // Removed as it's not essential for app functionality
        this.massaratValue = data.massaratValue || null;
        this.massaratId = data.massaratId || null;
        this.phone = data.phone || null;
        this.age = data.age || null;
        this.quranParts = data.quranParts || [];
        this.createdDate = data.createdDate || null;
        this.tenantId = data.tenantId || data.tenant_id || null;
        this.status = data.status || 'pending_review';
        this.statusLabel = data.statusLabel || 'تحت المراجعة';
    }
}
export default defineComponent({
    data() {
        return {
            students: [],
            courseDurationId: '',
            MEMORY: "",
            SELF_REVIEW: "",
            ATTENDANCE: "",
            masterDurationList: [],
            masterGoalsList: [], // Store goals list
            errorMessageStatus: false,
            errorMessage: "عذرا لا يوجد للدارسين غير مفعلين ",
            searchQuery: '',
            sortField: 'createdDate',
            sortOrder: 'desc',
            currentPage: 0,
            pageSize: 20,
            searchTimeout: null,
            totalElements: 0,
            showQuranPartsModal: false,
            selectedStudentQuranParts: [],
            selectedStudentName: '',
        }
    },
    computed: {
        filteredAndSortedStudents() {
            let filtered = this.students;
            
            // Sort (client-side sorting for now, since API doesn't support it)
            if (this.sortField) {
                filtered = [...filtered].sort((a, b) => {
                    let aVal = a[this.sortField];
                    let bVal = b[this.sortField];
                    
                    // Handle date sorting
                    if (this.sortField === 'createdDate') {
                        aVal = aVal ? new Date(aVal).getTime() : 0;
                        bVal = bVal ? new Date(bVal).getTime() : 0;
                    }
                    
                    // Handle string/number sorting
                    if (aVal === null || aVal === undefined) aVal = '';
                    if (bVal === null || bVal === undefined) bVal = '';
                    
                    if (typeof aVal === 'string') {
                        aVal = aVal.toLowerCase();
                        bVal = bVal.toLowerCase();
                    }
                    
                    if (aVal < bVal) return this.sortOrder === 'asc' ? -1 : 1;
                    if (aVal > bVal) return this.sortOrder === 'asc' ? 1 : -1;
                    return 0;
                });
            }
            
            return filtered;
        },
        paginatedStudents() {
            // Data comes directly from API paginated, just apply sorting
            return this.filteredAndSortedStudents;
        },
        totalPages() {
            return Math.ceil(this.totalElements / this.pageSize);
        },
        hasNext() {
            return (this.currentPage + 1) < this.totalPages;
        },
        startIndex() {
            return this.currentPage * this.pageSize;
        },
        endIndex() {
            const end = this.startIndex + this.students.length;
            return end > this.totalElements ? this.totalElements : end;
        },
        visiblePages() {
            const pages = [];
            const total = this.totalPages;
            const current = this.currentPage + 1;
            
            if (total <= 7) {
                // Show all pages if total pages <= 7
                for (let i = 1; i <= total; i++) {
                    pages.push(i);
                }
            } else {
                // Show pages with ellipsis
                if (current <= 3) {
                    // Show first 3, ellipsis, last 2
                    for (let i = 1; i <= 3; i++) {
                        pages.push(i);
                    }
                    pages.push('...');
                    pages.push(total - 1);
                    pages.push(total);
                } else if (current >= total - 2) {
                    // Show first 2, ellipsis, last 3
                    pages.push(1);
                    pages.push(2);
                    pages.push('...');
                    for (let i = total - 2; i <= total; i++) {
                        pages.push(i);
                    }
                } else {
                    // Show first, ellipsis, current-1, current, current+1, ellipsis, last
                    pages.push(1);
                    pages.push('...');
                    pages.push(current - 1);
                    pages.push(current);
                    pages.push(current + 1);
                    pages.push('...');
                    pages.push(total);
                }
            }
            
            return pages;
        }
    },
    watch: {
        searchQuery() {
            // Reset to first page and reload data when search query changes
            this.currentPage = 0;
            // Debounce search to avoid too many API calls
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }
            this.searchTimeout = setTimeout(() => {
                this.getAllNewStudents();
            }, 500); // Wait 500ms after user stops typing
        }
    },
    mounted() {
        this.getAllNewStudents();
        this.masterDurations();
        this.masterGoals(); // Load goals on mount
    },
    methods: {
        async getAllNewStudents() {
            try {
                const params = {
                    isNew: '1',
                    isDeactivated: '1',
                    page: this.currentPage,
                    size: this.pageSize,
                };
                
                // Add search parameter if search query exists
                if (this.searchQuery && this.searchQuery.trim() !== '') {
                    params.search = this.searchQuery.trim();
                }
                
                const response = await axios.get(process.env.VUE_APP_SERVICE_URL + url.get_all_students,
                    {
                        params: params,
                        headers: {
                            'X-Authorization': localStorage.getItem('token'),
                        },
                    },
                );
                console.log(response.data.result.data);
                // Handle paginated response format
                const responseData = response.data.result.data;
                const studentsArray = responseData.content || responseData; // Handle both old and new formats
                this.students = studentsArray.map(studentData => {
                    const student = new StudentDto(studentData);
                    // Debug: Log createdDate to verify it's being received
                    if (student.createdDate) {
                        console.log('Student createdDate:', student.fullName, student.createdDate, typeof student.createdDate);
                    }
                    return student;
                });
                this.totalElements = responseData.totalElements || this.students.length;
                
                if (this.students.length != 0) {
                    this.errorMessageStatus = false;
                }
                else {
                    this.errorMessageStatus = true;
                }
            } catch (error) {
                this.errorMessageStatus = true;
                console.error(error);
            }
        },
        canActivate(student) {
            return student.MEMORY && student.SELF_REVIEW && student.ATTENDANCE && student.courseDurationId;
        },
        async activateStudent(student) {
            console.log(student);
            try {
                // Get tenant_id from student object first, then from JWT token as fallback
                let tenantId = student.tenantId || student.tenant_id || null;
                
                // If not in student object, extract from JWT token
                if (!tenantId) {
                    try {
                        const token = localStorage.getItem('token');
                        if (token) {
                            const payload = JSON.parse(atob(token.split('.')[1]));
                            tenantId = payload.tenantId || payload.tenant_id || null;
                        }
                    } catch (e) {
                        console.warn('Could not extract tenantId from token:', e);
                    }
                }

                // Find goals by goal_code for this tenant
                const memoryGoal = this.masterGoalsList.find(g => g.goalCode === 'MEMORY');
                const selfReviewGoal = this.masterGoalsList.find(g => g.goalCode === 'SELF_REVIEW');
                const attendanceGoal = this.masterGoalsList.find(g => g.goalCode === 'ATTENDANCE');

                // Build list of missing goals
                const missingGoals = [];
                if (!memoryGoal) missingGoals.push('MEMORY');
                if (!selfReviewGoal) missingGoals.push('SELF_REVIEW');
                if (!attendanceGoal) missingGoals.push('ATTENDANCE');

                if (missingGoals.length > 0) {
                    const missingGoalsText = missingGoals.join(', ');
                    alert(`يرجى التأكد من وجود جميع الأهداف (${missingGoalsText}) للفرع الحالي.\n\nيمكنك إضافة الأهداف المفقودة من قائمة "إدارة الأهداف".`);
                    return;
                }

                const requestData = {
                    studentGoalDtoList: [
                        {
                            goalId: memoryGoal.id,
                            goalValue: student.MEMORY
                        },
                        {
                            goalId: selfReviewGoal.id,
                            goalValue: student.SELF_REVIEW
                        },
                        {
                            goalId: attendanceGoal.id,
                            goalValue: student.ATTENDANCE
                        }
                    ],
                    courseDurationId: student.courseDurationId,
                };

                // Add tenantId if available
                if (tenantId) {
                    requestData.tenantId = tenantId;
                }

                const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.activate_student + student.id,
                    requestData,
                    {
                        headers: {
                            'X-Authorization': localStorage.getItem('token'),
                        },
                    }
                );
                if (response != undefined) {
                    this.students = this.students.filter(u => u.id !== student.id);
                    console.log(response);
                    alert(response.data.result.mesAr);
                }
            } catch (error) {
                if (error.response.data != undefined) {
                    alert(error.response.data.messageAr);
                }
                else {
                    alert('حدث خطأ ما الرجاء المحاولة مرة اخرى');
                }
            }
        },
        masterDurations() {
            // Get tenant_id from JWT token
            let tenantId = null;
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    tenantId = payload.tenantId || payload.tenant_id || null;
                }
            } catch (e) {
                console.warn('Could not extract tenantId from token:', e);
            }

            // Build URL with tenantId as query parameter
            let urlWithParams = url.master_durations;
            if (tenantId) {
                urlWithParams += `?tenantId=${encodeURIComponent(tenantId)}`;
            }

            axios.get(process.env.VUE_APP_SERVICE_URL + urlWithParams)
                .then(response => {
                    this.masterDurationList = response.data.result.data.map(data => new MasterDurationDto(data));
                    console.log(this.masterDurationList);
                })
                .catch(error => {
                    console.error('Error fetching data', error);
                });
        },
        masterGoals() {
            // Get tenant_id from JWT token
            let tenantId = null;
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    tenantId = payload.tenantId || payload.tenant_id || null;
                }
            } catch (e) {
                console.warn('Could not extract tenantId from token:', e);
            }

            // MasterGoal extends TenantModel, so tenant scoping is automatically applied
            // We just need to fetch all active goals for the current tenant
            const params = {
                is_active: true,
                size: 100, // Get all goals
            };

            // Add tenantId to params if available
            if (tenantId) {
                params.tenantId = tenantId;
            }

            axios.get(process.env.VUE_APP_SERVICE_URL + url.goals_list, {
                params: params,
                headers: {
                    'X-Authorization': localStorage.getItem('token'),
                },
            })
                .then(response => {
                    // Handle paginated response
                    // Response structure: { result: { data: { data: [...], pagination: {...} } } }
                    const responseData = response.data?.result?.data;
                    if (responseData) {
                        // Check if it's paginated (has 'data' property) or direct array
                        const goalsArray = Array.isArray(responseData) 
                            ? responseData 
                            : (responseData.data || []);
                        this.masterGoalsList = goalsArray;
                        console.log('Master goals loaded:', this.masterGoalsList);
                        console.log('Goals count:', this.masterGoalsList.length);
                        // Log available goal codes for debugging
                        const goalCodes = this.masterGoalsList.map(g => g.goalCode).join(', ');
                        console.log('Available goal codes:', goalCodes);
                    } else {
                        console.warn('Unexpected response structure:', response.data);
                        this.masterGoalsList = [];
                    }
                })
                .catch(error => {
                    console.error('Error fetching goals', error);
                    this.masterGoalsList = [];
                });
        },
        formatDate(dateString) {
            if (!dateString || dateString === null || dateString === undefined || dateString === '') {
                return '-';
            }
            try {
                // Handle different date formats
                let date;
                if (typeof dateString === 'string') {
                    // Try parsing the date string
                    date = new Date(dateString);
                } else if (dateString instanceof Date) {
                    date = dateString;
                } else {
                    return '-';
                }
                
                // Check if date is valid
                if (isNaN(date.getTime())) {
                    console.warn('Invalid date:', dateString);
                    return '-';
                }
                
                // Format as YYYY-MM-DD with 12-hour time format (ص/م)
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                
                // Convert to 12-hour format
                let hours = date.getHours();
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                const ampm = hours >= 12 ? 'م' : 'ص';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                const hours12 = String(hours).padStart(2, '0');
                
                return `${year}-${month}-${day} ${hours12}:${minutes}:${seconds} ${ampm}`;
            } catch (e) {
                console.error('Error formatting date:', dateString, e);
                return dateString || '-';
            }
        },
        sortBy(field) {
            if (this.sortField === field) {
                // Toggle sort order if same field
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                // New field, default to ascending
                this.sortField = field;
                this.sortOrder = 'asc';
            }
            // Reset to first page when sorting
            this.currentPage = 0;
        },
        clearSearch() {
            this.searchQuery = '';
            this.currentPage = 0;
            this.getAllNewStudents();
        },
        previousPage() {
            if (this.currentPage > 0) {
                this.currentPage--;
                this.getAllNewStudents();
            }
        },
        nextPage() {
            if (this.hasNext) {
                this.currentPage++;
                this.getAllNewStudents();
            }
        },
        goToPage(page) {
            if (page === '...') return;
            const pageNum = parseInt(page) - 1;
            if (pageNum >= 0 && pageNum < this.totalPages) {
                this.currentPage = pageNum;
                this.getAllNewStudents();
            }
        },
        openQuranPartsModal(student) {
            this.selectedStudentQuranParts = student.quranParts || [];
            this.selectedStudentName = student.fullName || '';
            this.showQuranPartsModal = true;
        },
        closeQuranPartsModal() {
            this.showQuranPartsModal = false;
            this.selectedStudentQuranParts = [];
            this.selectedStudentName = '';
        },
    }
})
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Tailwind utility classes for enabled and disabled button states */
.enabled-button {
    @apply px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor w-20 h-10;
}

.disabled-button {
    @apply px-4 py-2 bg-gray-300 text-gray-500 rounded cursor-not-allowed w-20 h-10;
}

.button-background {
    background: #679884;
}
</style>